const DEFAULT_SEARCH_RADIUS_BY_LOCALE = {
  en: {
    relevance: 'auto',
    newest: '40000',
  },
  es: {
    relevance: 'auto',
    newest: '60000',
  },
  pt: {
    relevance: 'auto',
    newest: '60000',
  },
};
export const getDefaultSearchRadius = (sort = 'relevance') =>
  DEFAULT_SEARCH_RADIUS_BY_LOCALE[CURRENT_LOCALE][sort];
export const DEFAULT_SEARCH_RADIUS = getDefaultSearchRadius();
